import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import Header from "../components/header/clientHeader";
import Button from '../components/button/button';
import moment from "moment";
// Import supabase configuration
import supabase from "../config/supabase";
import { Buffer } from "buffer";
import {
    getClientNotification,
  } from "../redux/actions/actions";

function Notifications(){
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { clientNotification } = useSelector((state) => state.client);
    const [meetings, setMeetings] = useState([]);

    useEffect( () => {
      if(clientNotification.length> 0) {
        var meetings = clientNotification;
        meetings.map((m,index)=> {
          let date  = m.created_at && new Date(m.created_at);
          let newDate = date && new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
          var end = newDate ? moment(newDate).format('h:mm A') : "";
          m.time = end;
          
          var today = new Date();
          var yesterday = new Date(today);
    
          yesterday.setDate(yesterday.getDate() - 1);
    
          var checkDay = new Date(today);
    
          checkDay.setDate(checkDay.getDate() - 6);
    
          if((date.getMonth() == today.getMonth()) && (date.getDate() == today.getDate())){
            m.day = "Today"
          }
          else if((date.getMonth() == yesterday.getMonth()) && (date.getDate() == yesterday.getDate())){
            m.day = "Yesterday"
          }
          else if((date.getMonth() >= checkDay.getMonth()) && (date.getDate() == checkDay.getDate())){
            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            var d =days[date.getDay()];
    
            m.day = d ;
          }
          else{
            m.day = moment(date).format('MMM Do');
          }
        })
        
        setMeetings(meetings);
  
      } else {
        let client_invitation_id = localStorage.getItem('clientId');
        dispatch(getClientNotification(client_invitation_id));
      }
        
    },[clientNotification])

    const markAsRead = async(profileId) => {      
        let client_invitation_id = localStorage.getItem('clientId');

        if(client_invitation_id){
            var { data, error } = await supabase
            .from("notifications")
            .update({state : "read"})
            .match({client: client_invitation_id, profileId:profileId})
            
            if(data && data.length){
                dispatch(getClientNotification(client_invitation_id))
                navigate(`/meetingDetails?id=${Buffer.from(client_invitation_id, "utf-8").toString("base64")}`);            
            }
        }
    }

    const backToBoard = () => {
      let url = localStorage.getItem("clientUrl");
      url = url.split("client")[1];
      navigate(`/client${url}`);
    }

    return(
        <div className="w-full bg-[#F1F2F5] min-h-screen h-auto">
            <Header justView={false} showLogin={false} requestForm={true} />
            
             {/* show Meetings */}
             <div className="font-normal pl-3 pt-5 pb-3">Notifications</div>  

             <div className={`text-base px-2 `}>
                <div>
                    {meetings.length > 0 ? <div className="">
                        {
                          meetings.map((n,index) => ( <div className="bg-white-1 grid grid-cols-12 gap-x-3 hover:bg-green-2 cursor-pointer mt-1" key={index} onClick={() => markAsRead(n.profileId)}>
                              {/* Show dot */}
                              {
                                  n.state == "new" && <div className="col-span-12 w-3 h-3 bg-blue-4 rounded-full ml-2 mt-3"></div>
                              }
                              
                              {/* Show image */}
                              <div className={`bg-blue-9 w-10 h-10 col-span-2 rounded-full p-1 ml-5 ${n.state == "new" ? "-mt-2" : "mt-3"} `}>
                                  <img src="/av.jpg" />
                              </div>
                              <div className={`col-span-10 p-1 mb-2 ${n.state == "new" ? "-mt-2" : "mt-3"}`}> {n?.message.split("with")[0]} with <span className="font-medium">{n?.message.split("with")[1]}</span></div>
                              {/* Add space */}
                              <div className="col-span-2"></div>
                              <div className="col-span-10 text-sm font-medium text-grey-5 mb-3">{n.day} at {n.time}</div>                            
                          </div>
                          ))
                        } 
                        </div>: <div className="py-5 px-1 bg-white-1">You will receive notifications here</div>
                    }
                </div>
            </div >

            {/* Add button */}
            <div className="left-1/3 bottom-10 absolute -ml-3">
              <Button buttonType="Interview" value="Back to Board" onClick={() => backToBoard()}/>
            </div>

        </div>
    )
}

export default Notifications;